import { Card, useWindowWidth } from '@acceso/design-system';
import clsx from 'clsx';
import { useState } from 'react';

import { MOBILE_WIDTH } from '@/constants';

import { CNMC } from '../../types';

import { CNMCDetail } from './components/CNMCDetail/CNMCDetail';

type CNMCDetailCardProps = {
  cnmc: CNMC;
  isCollapsed: boolean;
  onCollapse: () => void;
};

export function CNMCDetailCard({ isCollapsed, cnmc, onCollapse }: CNMCDetailCardProps) {
  const { width } = useWindowWidth();
  const isMobile = width < MOBILE_WIDTH;
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Card
      title={cnmc.name}
      className="text-secondary-10"
      isAccordion={isMobile}
      isCollapsable={!isMobile}
      isOpen={isOpen}
      collapseDirection="right"
      lineSeparator={true}
      isCollapsed={isCollapsed && !isMobile}
      onCollapse={onCollapse}
      onOpen={() => setIsOpen(!isOpen)}
      classes={{
        header: clsx(!isMobile && 'py-3'),
      }}
    >
      <div className="body flex min-w-[449px] flex-col gap-size-12 self-stretch">
        <CNMCDetail cnmc={cnmc} />
      </div>
    </Card>
  );
}
